import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "rrdc_token";
export const LEVEL_KEY = "rrdc_level";
export const TOKEN_TS_KEY = "rrdc_token_ts";
export const CREW_TOKEN_KEY = "rrdc_crew_token";
export const CREW_INFO_KEY = "rrdc_crew_info";

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}
export function getLevel() {
  return sessionStorage.getItem(LEVEL_KEY);
}
export function setSession(token, level) {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(LEVEL_KEY, level);
  sessionStorage.setItem(TOKEN_TS_KEY, String(Date.now()));
}
export function clearSession() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(LEVEL_KEY);
  sessionStorage.removeItem(TOKEN_TS_KEY);
}

export function getCrewToken() { return sessionStorage.getItem(CREW_TOKEN_KEY); }
export function getCrewInfo() {
  try { return JSON.parse(sessionStorage.getItem(CREW_INFO_KEY) || "null"); } catch { return null; }
}
export function setCrewSession(token, info) {
  sessionStorage.setItem(CREW_TOKEN_KEY, token);
  sessionStorage.setItem(CREW_INFO_KEY, JSON.stringify(info || {}));
}
export function clearCrewSession() {
  sessionStorage.removeItem(CREW_TOKEN_KEY);
  sessionStorage.removeItem(CREW_INFO_KEY);
}

const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  // Crew session for ALL crew-only endpoints (except /crew/sign-in which creates the session);
  // staff/admin bearer for everything else.
  const url = config.url || "";
  const isCrewAuth = url.startsWith("/crew/") && !url.startsWith("/crew/sign-in");
  if (isCrewAuth) {
    const ct = getCrewToken();
    if (ct) config.headers.Authorization = `Bearer ${ct}`;
  } else {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err?.config?.url || "";
      const isCrewAuth = url.startsWith("/crew/") && !url.startsWith("/crew/sign-in");
      if (isCrewAuth) {
        // Crew token expired/invalid — clear crew session, let the page handle re-auth.
        clearCrewSession();
      } else {
        clearSession();
        if (typeof window !== "undefined" && window.location.pathname !== "/") {
          window.location.href = "/";
        }
      }
    }
    return Promise.reject(err);
  },
);

export default api;
